import React, { FC, useCallback } from 'react';

import {
	BUTTON_TYPES,
	EvChipItem,
	EvChips,
	EvFlexColumn,
	EvPopup,
	TITLE_MODES
} from '@evinced-private/ui-common';

import { LABEL_MANAGEMENT_VALUES_MODAL_DAID } from 'data-automation-ids/LabelManagementAutomationIds';
import { PLATFORM_APP_ID } from 'src/common/consts/dom-consts';

import { VALUES_MODAL_WIDTH } from '../LabelsTable.constants';
import { LABELS_TABLE_LABELS } from '../LabelsTable.labels';

import { ValuesModalProps } from './ValuesModal.types';

export const ValuesModal: FC<ValuesModalProps> = ({ isOpen, labelKey, values, onClose }) => {
	const chips: EvChipItem[] = values.map((v) => ({ id: v, label: v }));

	const handleClose = useCallback(() => {
		onClose();
	}, [onClose]);

	const buttons = [
		{
			title: LABELS_TABLE_LABELS.VALUES_MODAL_CLOSE,
			onClick: handleClose,
			type: BUTTON_TYPES.GHOST
		}
	];

	return (
		<EvPopup
			appElement={PLATFORM_APP_ID}
			isOpen={isOpen}
			isControlled
			isCentered
			isBgTransparent
			title={LABELS_TABLE_LABELS.VALUES_MODAL_TITLE(labelKey)}
			titleMode={TITLE_MODES.MAIN}
			popupWidth={VALUES_MODAL_WIDTH}
			buttons={buttons}
			onClose={handleClose}
		>
			<EvFlexColumn dataAutomationId={LABEL_MANAGEMENT_VALUES_MODAL_DAID}>
				<EvChips chips={chips} wrap="WRAP" />
			</EvFlexColumn>
		</EvPopup>
	);
};
